module.exports = __webpack_public_path__ + "assets/img/zhfour.86c819ee.png";